class CampaignHeading extends HTMLElement {
  constructor() {
    super();

    this.heading = this.querySelector('.campaign-heading__heading');
    this.headingLine = this.heading.querySelector('.line');

    this.setup();
  }

  setup() {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 990px)', () => {
      this.setSize();

      return () => {
        this.heading.style.fontSize = ``;
      };
    });
  }

  setSize() {
    const height = this.heading.offsetHeight;
    const headingHeight = this.headingLine.offsetHeight * 3;
    const fontSize = parseInt(window.getComputedStyle(this.heading).fontSize);
    const vh = (((height / headingHeight) * fontSize) / height - 0.08) * 100;
    this.heading.style.fontSize = `${vh}svh`;
  }
}

customElements.define('campaign-heading', CampaignHeading);
